import Modal from "react-modal";
import "./style.scss";

// Generic yes/no confirmation modal. The plan calls for reusing an existing
// "ConfirmActionModal" for the reset confirmation, but that component isn't
// present in this checkout (git history shows an ActionModal/ConfirmActionModal.js
// that was removed well before this branch's base) - this is a fresh,
// intentionally generic component filling that reuse slot, styled after the
// existing ModalEvent/react-modal convention so any other feature can reuse
// it too.
const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="custom-modal confirm-action-modal">
      <div className="confirm-action-modal-header">
        <h3>{title}</h3>
      </div>
      {message && <div className="confirm-action-modal-message">{message}</div>}
      <div className="confirm-action-modal-actions">
        <button
          type="button"
          className="confirm-action-modal-cancel"
          onClick={onCancel}>
          {cancelLabel}
        </button>
        <button
          type="button"
          className="confirm-action-modal-confirm"
          onClick={onConfirm}>
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmActionModal;
